// extracted by mini-css-extract-plugin
export default {"tabBtns":"Sidebar_tabBtns__Wk49c","scrollbar":"Sidebar_scrollbar__+OQ36","textBottomMargin":"Sidebar_textBottomMargin__GHux+","tabs":"Sidebar_tabs__ZhT4W"};